// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"4261b7463ed3d25c8717","777":"f913eae6896d23802e85"}[chunkId] + ".js";
};